import { BackendResponse } from "../BackendResponse";
import { FormDataWithKeyCheck } from "../FormDataFactory";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CreateNewCVPCandidateParametersSimple } from "./CreateNewCVPCandidateParametersSimple";

export interface CreateProfileResponse extends BackendResponse {
  item: string;
}

export interface CreateProfileParameters extends NextApiParams {
  formData: FormDataWithKeyCheck<CreateNewCVPCandidateParametersSimple>;
}

export const createProfile = withNextApi<
  CreateProfileResponse,
  CreateProfileParameters
>("/auth/CreateProfile");
